import Api from './Api'

class Form extends Api {
  constructor(carePlanId, id) {
    super()

    this.carePlanId = carePlanId
    this.id = id
  }

  get url() {
    return `/care_plans/${this.carePlanId}/forms`
  }
}

export default Form
